import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import moment from 'moment';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withTableName from '../../common/withTableName';
import Header from '../../components/Header';
import PreferenceOptions from '../../components/Models/PreferenceOptions';
import withSetsListStateStorage from '../../common/withSetsListStateStorage';
import withPreferenceOptions from '../../common/withPreferenceOptions';
import { onGoBack } from '../../common/globals';
import {
  getTableCaseByCaseId,
  getAllPreferences
} from '../../utils/db';
import Bugsnag from '../../helpers/bugsnag';
import CaseChangesNoLonger from '../../components/Models/CasesChangesNoLonger';
import withSelectedSetsPayload from '../../common/withSelectedSetsPayload';

class SetsPreferences extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setsPreferences: [],
      CaseRes: '',
      selectedPreference: [],
      selectedSetsCount: 0
    };
    this.preferenceOptionsModal = null;
    this.caseChangesNoLonger = null;
  }

  componentDidMount() {
    try {
      this.preferenceOptionsModal = new window.bootstrap.Modal(window.$('#preferenceOptionsModal'));
      this.caseChangesNoLonger = new window.bootstrap.Modal(window.$('#CaseChangesNoLongerModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getPreferenceData = async () => {
    try {
      const { CaseRes } = this.state;
      const getPreferencesRes = await getAllPreferences();
      if (CaseRes !== undefined) {
        const getCaseTypePreferenceList
          = getPreferencesRes.filter((item) => item.CaseType === CaseRes.CaseType);
        const newPreferenceArray = getCaseTypePreferenceList.filter(
          (item) => (item.PreferenceName !== '' && item.PreferenceName !== null)
        );
        const groups = _.groupBy(newPreferenceArray, 'PreferenceName');
        this.setState({
          setsPreferences: groups
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onOpenPreferenceOptionsPopup = async (data) => {
    try {
      const {
        setsPreferences, selectedSetsCount, CaseRes
      } = this.state;
      const { params: { id }, tableName, setSelectedSetsPayload } = this.props;

      const caseDetail = await getTableCaseByCaseId(id, tableName);
      if (caseDetail && caseDetail.DGR === '1') {
        this.caseChangesNoLonger.show();
        return;
      }

      if (selectedSetsCount === 0
        && (CaseRes.Comments === null || CaseRes.Comments === '')
        && (CaseRes.RepNotes === null || CaseRes.RepNotes === '')) {
        const {
          setPreferenceOptions, goBack
        } = this.props;
        const preferenceOptions = {};
        let preferenceComments = {};
        let preferenceRepNotes = {};

        setSelectedSetsPayload([...setsPreferences[data]]);

        setsPreferences[data].map((set) => {
          set.CasePlanID = '';
          const {
            SetName, Quantity, Comments, RepNotes
          } = set;
          preferenceOptions[SetName] = Number(Quantity);
          preferenceComments = Comments;
          preferenceRepNotes = RepNotes;
        });
        setPreferenceOptions({
          data: preferenceOptions, type: 'append', preferenceComments, preferenceRepNotes
        });
        this.preferenceOptionsModal.hide();
        browserHistory.push(`/manage-case/${CaseRes.id}/sets`);
        onGoBack(goBack);
      } else {
        this.preferenceOptionsModal.show();
      }
      this.setState({
        selectedPreference: setsPreferences[data]
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onHidePreferenceOption = () => {
    try {
      this.preferenceOptionsModal.hide();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const { params: { id }, tableName, setsListStateStorage } = this.props;
      const caseRes = await getTableCaseByCaseId(id, tableName);
      this.setState({
        CaseRes: caseRes
      });
      let selectedSetsCount = 0;
      if (Object.keys(setsListStateStorage).length > 0) {
        const setQty = Object.values(setsListStateStorage.selectedSetsQty);
        setQty.map((value) => {
          selectedSetsCount += Number(value);
        });
      } else {
        caseRes.case_sets.map(({ Quantity }) => {
          selectedSetsCount += Number(Quantity);
        });
      }
      this.setState({ selectedSetsCount });
      await this._getPreferenceData();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      setsPreferences, CaseRes, selectedPreference, selectedSetsCount
    } = this.state;
    const { goBack } = this.props;
    let caseDate;
    if (CaseRes !== undefined) {
      caseDate = moment(CaseRes.CaseDate).format('YYYY-MM-DD');
    }
    return (
      <>
        <section className="list-section">
          <Header
            title="Preferences"
            goBack={() => onGoBack(goBack)}
          />
          <section className="list-section">
            <div className="container">
              <ul className="select-list list-unstyled">
                {
                  Object.keys(setsPreferences).length > 0
                    ? Object.keys(setsPreferences).map((key, index) => (
                      <Link
                        style={{ cursor: 'pointer' }}
                        key={index}
                        onClick={() => {
                          this._onOpenPreferenceOptionsPopup(key, index);
                        }}
                      >
                        <li>{key}</li>
                      </Link>
                    )) : <p className="text-center mt-5">No Preferences Found.</p>
                }
              </ul>
            </div>
          </section>
        </section>
        <PreferenceOptions
          caseDate={caseDate}
          selectedPreference={selectedPreference}
          caseRes={CaseRes}
          selectedSetsCount={selectedSetsCount}
          onHide={this._onHidePreferenceOption}
        />
        <CaseChangesNoLonger
          id={CaseRes.id}
        />
      </>
    );
  }
}

const withForm = reduxForm({
  form: 'SetsPreferencesForm',
});

export default withPreferenceOptions(
  withSetsListStateStorage(
    withTableName(
      withGoBack(
        withForm(
          withNotify(
            withLoader(
              withSelectedSetsPayload(
                SetsPreferences
              )
            )
          )
        )
      )
    )
  )
);
